<template>
	<div class="p-1 p-md-5 border rounded-3 bg-light">
		<div v-if="!submitted">
			<div class="mb-3">
				<label for="switchActive">Активность * </label>
				<div class="form-check form-switch">
					<input class="form-check-input" type="checkbox" role="switch" id="switchActive" v-model="event.active" />
					<label class="form-check-label" for="switchActive">Активность</label>
				</div>
				<label for="switchStatus">Статус события *</label>
				<div class="form-check form-switch">
					<input class="form-check-input" type="checkbox" role="switch" id="switchStatus" v-model="event.published" />
					<label class="form-check-label" for="switchStatus">Опубликовано</label>
				</div>
			</div>

			<div class="mb-3">
				<label for="title">Название события *</label>
				<input type="text" class="form-control" id="title" v-model="event.title" />
			</div>

			<div class="mb-3">
				<label for="description">Описание события *</label>
				<editor api-key="ncn0j2opslddg34obf2f3rxhgy9j2tqynd0wdvywou2bj9w7" :init="editor" v-model="event.description" />
			</div>

			<div class="mb-3">
				<label class="form-label" for="dateStart">Тип события *</label>
				<select class="form-select" aria-placeholder="Тип события" v-model="event.type">
					<option disabled value="">Выберите Тип события</option>
					<option v-for="(type, index) in getEventTypes" :key="index" v-bind:value="type._id">{{ type.name }}</option>
				</select>
			</div>

			<div class="mb-3">
				<label class="form-label" for="dateStart">Проект</label>
				<select class="form-select" aria-placeholder="Тип события" v-model="event.project">
					<option disabled value="">Выберите проект</option>
					<option v-for="(project, index) in getProjects" :key="index" v-bind:value="project._id">
						{{ project.name }}
					</option>
				</select>
			</div>

			<div class="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-around align-items-center">
				<div class="mb-3">
					<label class="form-label" for="dateStart">Дата начала *</label>
					<div class="input-group mb-3">
						<div class="input-group-text">
							<input
								class="form-check-input mt-0"
								type="checkbox"
								checked
								disabled
								aria-label="Checkbox for following text input"
							/>
						</div>
						<date-picker
							id="dateStart"
							input-class="form-control"
							v-model="eventDateStart"
							type="datetime"
							valueType="date"
						>
							<template v-slot:header="{ emit }">
								<button class="mx-btn mx-btn-text" @click="emit(new Date())">Сегодня</button>
							</template>
						</date-picker>
					</div>
				</div>

				<div class="mb-3">
					<label class="form-label" for="dateEnd">Дата окончания</label>
					<div class="input-group mb-3">
						<div class="input-group-text">
							<input
								class="form-check-input mt-0"
								type="checkbox"
								v-model="dateEndEnabled"
								aria-label="Checkbox for following text input"
							/>
						</div>
						<date-picker
							id="dateEnd"
							input-class="form-control"
							v-model="eventDateEnd"
							type="datetime"
							valueType="date"
							:disabled="!dateEndEnabled"
						>
							<template v-slot:header="{ emit }">
								<button class="mx-btn mx-btn-text" @click="emit(new Date())">Сегодня</button>
							</template>
						</date-picker>
					</div>
				</div>
			</div>

			<div class="border mb-3 pb-3">
				<label for="previewGrid" class="form-label">Превью в сетку/страницу</label>
				<div v-if="event.gridImage && !event.previewGrid.length" class="col col-md-3">
					<img :src="event.gridImage" class="img-fluid" />
				</div>
				<handy-uploader
					:documentAttachment.sync="event.previewGrid"
					:fileUploaderType="'thumbnail'"
					:badgeCounter="false"
					:thumb="true"
					:changeFileName="false"
					:maxFileSize="102400"
					:imageCompressor="true"
					:imageCompressLevel="0.8"
					:maxFileCount="1"
					:editPermission="false"
					:lang="'custom'"
					:customLang="handyRuLang"
					:cols="12"
					:btnColor="'#0de9fd'"
					:fileAccept="'image/png,image/gif,image/jpeg,image/webp'"
				>
				</handy-uploader>
			</div>

			<div class="mb-3">
				<label for="switchStatus">Показывать в слайдере</label>
				<div class="form-check form-switch">
					<input
						class="form-check-input"
						type="checkbox"
						role="switch"
						id="switchshowInSlider"
						v-model="event.showInSlider"
					/>
					<label class="form-check-label" for="switchshowInSlider">Да</label>
				</div>
			</div>

			<div class="bg-info p-2 text-dark bg-opacity-10" v-if="event.showInSlider">
				<p class="lead">Превью в слайдер</p>
				<div class="mb-3 d-flex justify-content-around">
					<div>
						<label class="form-label">Малый (320х210)</label>
						<div v-if="event.sliderImageMin && !event.previewSliderImageMin.length" class="col col-md-6">
							<img :src="event.sliderImageMin" class="img-fluid" />
						</div>
						<handy-uploader
							:documentAttachment.sync="event.previewSliderImageMin"
							:fileUploaderType="'thumbnail'"
							:badgeCounter="false"
							:thumb="true"
							:changeFileName="false"
							:maxFileSize="102400"
							:imageCompressor="true"
							:imageCompressLevel="0.8"
							:maxFileCount="1"
							:editPermission="false"
							:lang="'custom'"
							:customLang="handyRuLang"
							:cols="12"
							:btnColor="'#0de9fd'"
							:fileAccept="'image/png,image/gif,image/jpeg,image/webp'"
						>
						</handy-uploader>
					</div>
					<div>
						<label class="form-label">Большой (1270х400)</label>
						<div v-if="event.sliderImageBig && !event.previewSliderImageBig.length" class="col col-md-6">
							<img :src="event.sliderImageBig" class="img-fluid" />
						</div>
						<handy-uploader
							:documentAttachment.sync="event.previewSliderImageBig"
							:fileUploaderType="'thumbnail'"
							:badgeCounter="false"
							:thumb="true"
							:changeFileName="false"
							:maxFileSize="102400"
							:imageCompressor="true"
							:imageCompressLevel="0.8"
							:maxFileCount="1"
							:editPermission="false"
							:lang="'custom'"
							:customLang="handyRuLang"
							:cols="12"
							:btnColor="'#0de9fd'"
							:fileAccept="'image/png,image/gif,image/jpeg,image/webp'"
						>
						</handy-uploader>
					</div>
				</div>
				<div class="mb-3">
					<label for="switchStatus">Скрыть название и дату в слайдере</label>
					<div class="form-check form-switch">
						<input
							class="form-check-input"
							type="checkbox"
							role="switch"
							id="switchHideTextInSlider"
							v-model="event.hideTextInSlider"
						/>
						<label class="form-check-label" for="switchHideTextInSlider">Да</label>
					</div>
				</div>
				<div class="mb-3">
					<label for="sliderSort" class="form-label">Сортировка в слайдере</label>
					<input
						type="number"
						class="form-control"
						id="sliderSort"
						required
						v-model="event.sliderSort"
						name="sliderSort"
					/>
				</div>
			</div>

			<div class="mb-3">
				<label for="maxCompetitors" class="form-label">Лимит участников</label>
				<input
					type="number"
					class="form-control"
					id="maxCompetitors"
					required
					v-model="event.maxCompetitors"
					name="maxCompetitors"
				/>
			</div>

			<div class="mb-3">
				<label for="title">Текст для зарегистрировавшихся (PlainText/HTML)</label>
				<textarea rows="3" class="form-control" id="afterJoinText" v-model="event.afterJoinText"></textarea>
			</div>

			<button @click="updateEvent" v-if="event._id" class="btn btn-primary mt-2 mt-md-0">
				<span v-show="loading" class="spinner-border spinner-border-sm"></span> Сохранить
			</button>
			<button @click="createEvent" v-else class="btn btn-primary mt-2 mt-md-0 ml-md-2">
				<span v-show="loading" class="spinner-border spinner-border-sm"></span> Создать
			</button>
			<button @click="deleteEvent" v-if="event._id" class="btn btn-danger mt-2 mt-md-0 ml-2">Удалить</button>
			<button @click="statsEvent" v-if="event._id" class="btn btn-info mt-2 mt-md-0 ml-md-2">Статистика</button>
			<button @click="gotoEvent" v-if="event._id" class="btn btn-warning mt-2 mt-md-0 ml-2">На страницу</button>

			<!-- <div class="alert alert-danger my-2" v-if="message != ''">{{ message }}</div> -->
			<template v-if="qrLink" class="mb-2">
				<hr />

				<div class="text-center col-8 offset-0 col-md-4 offset-md-0">
					{{ qrLink }}
					<img
						:src="
							'https://barcode.tec-it.com/barcode.ashx?data=' +
							qrLink +
							'&code=MobileQRCode&dpi=300&imagetype=Png&eclevel=H'
						"
						class="img-fluid p-2 p-md-3 border bg-white"
					/>
				</div>
			</template>
		</div>

		<div v-else>
			<h4 class="text-center">Событие добавлено</h4>
			<div class="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-center align-items-center">
				<button class="btn btn-primary me-sm-3" @click="newEvent">Создать событие</button> &nbsp;
				<router-link :to="{ path: '/events' }" class="btn btn-outline-secondary">Сетка событий</router-link>
			</div>
		</div>

		<sweet-modal icon="success" ref="okModal">
			{{ successMsg }}
			<sweet-button class="btn btn-success" slot="button" @click="closeModal()"> Ок</sweet-button>
		</sweet-modal>
		<sweet-modal icon="error" blocking ref="errModal">
			{{ errorMsg }}
			<sweet-button class="btn btn-danger" slot="button" @click="closeModal()"> Закрыть</sweet-button>
		</sweet-modal>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import EventDataService from "../../services/event.service";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "../../assets/css/datepicker.scss";
import "vue2-datepicker/locale/ru";
import Editor from "@tinymce/tinymce-vue";
import handyUploader from "handy-uploader/src/components/handyUploader";
import handyRuLang from "./handy-upload-ru";

export default {
	name: "edit-event",
	components: { DatePicker, Editor, handyUploader },
	metaInfo: {
		title: "Редактор события",
	},
	data() {
		return {
			event: {
				id: null,
				title: "",
				description: "",
				active: true,
				published: true,
				dateStart: "",
				dateEnd: "",
				type: null,
				project: null,
				maxCompetitors: 0,
				previewGrid: [],
				previewSliderImageMin: [],
				previewSliderImageBig: [],
				showInSlider: false,
				hideTextInSlider: false,
				sliderSort: 10,
				afterJoinText: "",
			},
			submitted: false,
			currentEvent: null,
			qrLink: null,
			dateEndEnabled: false,
			eventDateStart: new Date("dd.mm.YYYY"),
			eventDateEnd: null,
			successMsg: "",
			errorMsg: "",
			message: "",
			loading: false,
			handyRuLang: handyRuLang,
			editor: {
				// language: "ru_RU",
				height: 300,
				menubar: false,
				plugins: [
					"advlist autolink lists link image charmap print preview anchor",
					"searchreplace visualblocks code fullscreen",
					"insertdatetime media table paste code help wordcount",
				],
				toolbar:
					"undo redo | formatselect | bold italic backcolor | \
							alignleft aligncenter alignright alignjustify | \
							bullist numlist  | link unlink image | removeformat code",
				images_upload_handler: (blobInfo, success) => {
					const img = "data:image/jpeg; base64," + blobInfo.base64();
					success(img);
				},
			},
		};
	},
	computed: {
		...mapGetters({
			getEventTypes: "params/GET_EVENT_TYPES",
			getProjects: "params/GET_PROJECTS",
		}),
	},
	methods: {
		createEvent() {
			this.message = "";
			this.loading = true;
			let data = {
				...this.event,
				dateStart: this.eventDateStart,
				dateEnd: this.eventDateEnd,
			};

			if (!this.dateEndEnabled) {
				data.dateEnd = null;
			}

			EventDataService.create(data)
				.then((response) => {
					this.event.id = response.data._id;
					this.submitted = true;
					this.successMsg = "Событие создано";
					this.$refs.okModal.open();
					this.loading = false;
				})
				.catch((err) => {
					this.message = err.response.data.message;
					this.errorMsg = err.response.data.message;
					this.$refs.errModal.open();
					this.loading = false;
				});
		},

		newEvent() {
			this.submitted = false;
			this.event = {};
		},

		getEvent(id) {
			EventDataService.get(id)
				.then((response) => {
					this.currentEvent = response.data;
					Object.assign(this.event, this.currentEvent);

					this.eventDateStart = new Date(this.event.dateStart);

					if (this.event.dateEnd !== null) {
						this.dateEndEnabled = true;
						this.eventDateEnd = new Date(this.event.dateEnd);
					} else {
						this.event.dateEnd = null;
					}

					this.getURL();
				})
				.catch((err) => {
					this.message = err.response.data.message;
					this.errorMsg = err.response.data.message;
					this.$refs.errModal.open();
				});
		},

		updateEvent() {
			this.message = "";
			this.loading = true;

			let data = {
				...this.event,
				dateStart: this.eventDateStart,
				dateEnd: this.eventDateEnd,
			};

			if (!this.dateEndEnabled) {
				data.dateEnd = null;
			}

			EventDataService.update(this.currentEvent._id, data)
				.then(() => {
					this.message = "The event was updated successfully!";
					this.successMsg = "Событие сохранено успешно";
					this.$refs.okModal.open();
					// this.$router.go(this.$router.currentRoute);
					this.loading = false;
				})
				.catch((err) => {
					this.message = err.response.data.message;
					this.errorMsg = err.response.data.message;
					this.$refs.errModal.open();
					this.loading = false;
				});
		},

		deleteEvent() {
			this.message = "";
			this.loading = true;
			EventDataService.delete(this.currentEvent._id)
				.then((response) => {
					alert(response.data.message);
					this.$router.push({ name: "events" });
					this.loading = false;
				})
				.catch((err) => {
					this.message = err.response.data.message;
					this.errorMsg = err.response.data.message;
					this.$refs.errModal.open();
					this.loading = false;
				});
		},
		statsEvent() {
			this.$router.push({ name: "event-stats", params: { id: this.currentEvent._id } });
		},
		gotoEvent() {
			this.$router.push({ name: "event-details", params: { id: this.currentEvent.shortId } });
		},
		getURL() {
			if (this.event.shortId.length) {
				this.qrLink = window.location.origin + "/events/" + this.event.shortId;
			} else {
				this.qrLink = null;
			}
		},
		closeModal() {
			this.$refs.okModal.close();
			this.$refs.errModal.close();
		},
	},
	mounted() {
		this.message = "";
		if (Object.keys(this.$route.params).length > 0) {
			this.getEvent(this.$route.params.id);
		}
	},
};
</script>

<style scoped></style>
